import content from "app-content";
import InitialisationError from "../InitialisationError";

const NoConnectionError = () => (
  <InitialisationError
    title={
      content.saved_items_api_failure_full_page_error_no_internet_connection_title
    }
    messages={[
      content.saved_items_api_failure_full_page_error_no_internet_connection_message
    ]}
  />
);

export default NoConnectionError;
